import { render, staticRenderFns } from "./UniversityFacultyGender.vue?vue&type=template&id=ae27a90e&scoped=true&"
import script from "./UniversityFacultyGender.vue?vue&type=script&lang=js&"
export * from "./UniversityFacultyGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae27a90e",
  null
  
)

export default component.exports